export default {
    baseURL: (window as any).backendURL, 
    headers: {'Accept': 'application/vnd.github.v3+json'}
  }